<template>
  <section class="collect">
    <com-tabs
      :list="mineInfo.obj.tabsList"
      class="collect-tabs"
      :default-tab="activeTab"
      direction="column"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="collect-tabs-item"
        >
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>

    <div class="collect-panel">
      <div v-show="activeTab == 0" class="collect-data">
        <template v-if="data0.length !=0">
          <div v-for="(item0,index0) in data0" :key="index0" class="cell-item">
            <com-card2
              :obj="item0"
              img-height="217px"
              :is-edit="false"
              @control="handleControl4"
              @control1="handleRouteDto"
              @path="handleRouteDto"
            />
          </div>
          <div class="cell-item" />
        </template>
        <template v-else>
          <div class="nullData">
            <NullData
              text="暂无收藏数据"
            />
          </div>
        </template>
      </div>

      <div v-show="activeTab == 1" class="collect-data">
        <template v-if="this.data2.length !=0">
          <div v-for="(item1,index1) in data2" :key="index1" class="cell-item">
            <com-card2
              :obj="item1"
              img-height="217px"
              @control="handleControl"
              @control1="handleEdit"
              @path="handleControl1"
            />
          </div>
          <div class="cell-item" />
        </template>
        <template v-else>
          <div class="nullData">
            <NullData
              text="暂无收藏数据"
            />
          </div>
        </template>
      </div>

      <div v-show="activeTab == 2" class="collect-data3">
        <template>
          <com-table
            :data="data1"
            :configs="mineInfo.obj.table"
            :is-route-dto="true"
            is-route-dto-str="article_name"

          >
            <template v-slot:operate="{ row }">
              <el-button type="text" @click="handleRouteDto2(row)">
                查看
              </el-button>
              <span class="pad-row4">/</span>
              <el-button type="text" @click="handleControl2(row)">
                取消收藏
              </el-button>
            </template>
          </com-table>
          <!-- </div> -->
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import { mapGetters } from 'vuex'

import NullData from '@/components/NullData'
import comTabs from '@/components/comTabs'
import comCard2 from '@/components/comCard2'
import comTable from '@/components/comTable'
export default {
  components: { comTabs, comCard2, comTable, NullData },
  data() {
    return {
      requestParams: {
        page: 1,
        page_size: 9999,
        collection_type: 1 // 标准收藏
      },
      requestParams1: {
        page: 1,
        page_size: 9999,
        collection_type: 2 // 案例收藏
      },
      requestParams0: {
        page: 1,
        page_size: 9999,
        collection_type: 3 // 示范空间
      },
      requestParams2: {
        collection_id: null,
        collection_type: 2
      },
      requestParams3: {
        collection_id: null,
        collection_type: 1
      },
      requestParams4: {
        collection_id: null,
        collection_type: 3
      },
      mineInfo: mock.mine.collect.viewInfo,
      mineInit: mock.mine.collect.init,
      data1: [], // 方案 案例
      data2: [], // 标准
      data3: [],
      data0: [],
      activeTab: 0,
      loading: false
      // timer: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    })
  },
  created() {
    this.loading = true
    this.init()
    // this.init(this.requestParams);
  },
  mounted() {
    // this.init()
  },
  // beforeDestroy() {
  //   clearInterval(this.timer)
  //   this.timer = null
  // },
  methods: {
    handleEdit(v) {
      this.requestParams2.collection_id = v.collection_id
      const obj = {}
      obj.design_id = v.new_design_id
      obj.dest = 1
      api.square.update.dto(obj).then((res) => {
        this.$router.push({
          path: '/square/set',
          query: {
            src: res.data.url
          }
        })
      })
    },
    handleRouteDto2(row) {
      this.$router.push({
        path: `/notes/standard/details`,
        query: {
          id: row.collection_id
        }
      })
    },
    handleControl1(v) {
      this.$router.push({
        path: '/square/details',
        query: {
          id: v.collection_id
        }

      })
    },
    handleControl3(v) {
      this.$router.push({
        path: '/notes/standard/details',
        query: {
          id: v.collection_id
        }
      })
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    handleControl(v) {
      this.requestParams2.collection_id = v.collection_id
      this.$confirm('确认取消收藏吗?', '提示', {})
        .then(() => {
          api.mine.delete.collect(this.requestParams2).then((res) => {
            this.$message.success('取消收藏成功')
            this.init()
          })
        })
        .catch(() => {})
    },
    handleControl2(v) {
      this.requestParams3.collection_id = v.collection_id
      this.$confirm('确认取消收藏吗?', '提示', {})
        .then(() => {
          api.mine.delete.collect(this.requestParams3).then((res) => {
            this.$message.success('取消收藏成功')
            this.init()
          })
        })
        .catch(() => {})
    },
    handleControl4(v) {
      this.requestParams4.collection_id = v.collection_id
      this.$confirm('确认取消收藏吗?', '提示', {})
        .then(() => {
          api.mine.delete.collect(this.requestParams4).then((res) => {
            this.$message.success('取消收藏成功')
            this.init()
          })
        })
        .catch(() => {})
    },
    // async handleControl(v) {
    //   let obj = {
    //     design_id: v.new_design_id,
    //     dest: 1,
    //   };
    //   let src = await this.mineInit.url(obj);
    //   this.$router.push({
    //     path: "/square/set",
    //     query: {
    //       src,
    //     },
    //   });
    // },
    async init() {
      this.data0 = await this.mineInit.data1(this.requestParams0)
      this.data2 = await this.mineInit.data1(this.requestParams1)
      this.data1 = await this.mineInit.data2(this.requestParams)
      // this.timer = setInterval(() => {
      //   setTimeout(async() => {
      //     this.data0 = await this.mineInit.data1(this.requestParams0)
      //     this.data2 = await this.mineInit.data1(this.requestParams1)
      //     this.data1 = await this.mineInit.data2(this.requestParams)
      //   }, 0)
      // }, 6000)

      this.loading = false
    },
    changeTab(x, y) {
      this.activeTab = x
      // this.requestParams.collection_type = y;
      this.init()
    },
    handleRoute() {
      if (this.btnText == '添加方案') {
        this.$router.push({
          path: '/square/space'
        })
      } else {
        this.$router.push({
          path: '/notes/standard'
        })
      }
    },
    handleRouteDto(v) {
      let str
      if (this.activeTab == 1) {
        str = '/equip/space/details'
        this.$router.push({
          path: str,
          query: {
            id: v.id
          }
        })
      } else if (this.activeTab == 0) {
        str = '/room/roam'
        this.$router.push({
          path: str,
          query: {
            src: v.vr_url
          }
        })
      } else {
        str = '/notes/standard/details'
        this.$router.push({
          path: str,
          query: {
            id: v.collection_id
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.collect {
@include fun-layout(1);
  display: flex;
  justify-content: center;
  width: 66%;
  margin: 0 auto;
  &-data{
    // @include fun-layout();
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
  }
  &-data3{
    > section{
      padding: 10px 0 0 10px;
    }
  }
  .cell-item {
    padding: 10px;
  }
  &-hand {
    background: url("../../../assets/bg/bg-mine1.jpg") no-repeat;
    background-size: 100% 100%;
    height: 30%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 35px 0 80px;
    > div {
      display: flex;
      align-items: center;
      > div {
        color: #fff;
        margin: 0 20px;
        line-height: 30px;
      }
    }
    > button {
      @include fun-btn(3)
    }
  }
  &-tabs {
    display: flex;
    flex-direction: column;
    margin-right: 18px;
    &-item {
       text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 50px;
      width: 140px;
      cursor: pointer;
      margin-bottom: 2px;
    }
    .activeTab {
      @include fun-active(2);
    }
  }
  &-panel {
    height: 100%;
    width: 1702px;
    min-height: 750px;

  }
}
.cell-item {
  // width: calc(100% / 3);
  width:33%;
}
.nullData{
  margin: 0 auto;
  margin-top: 10vh;
  color: #909399;
}
</style>
